  // チェックボックスの要素を取得
  const myCheckbox = document.getElementById('myCheckbox');
  // ボタンの要素を取得
  const submitButton = document.getElementById('submitButton');
  // チェックボックスの状態が変わったときの処理
  myCheckbox.addEventListener('change', function () {
    // チェックボックスがチェックされている場合はボタンを有効にし、そうでない場合は無効にする
    submitButton.disabled = !myCheckbox.checked;
  });
